import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/Loader";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

export default function AdminApp() {
  const { user, ready } = useAuth();
  if (!ready) return <Loader />;
  return user ? <AdminDashboard /> : <AdminLogin />;
}
